/** todo atm no need? */

export default {
  id: null,
  interval: null,
  text: null,
  type: null,
  dosagealternativedatas: null,
};
